export const createGuideUrl = '/api/guides'
export const shareGuideUrl = 'TODO'
export const authenticationUrl = 'TODO'
export const unauthenticationUrl = 'TODO'



// WEBPACK FOOTER //
// ./src/redux/api/index.js